import _ from 'underscore';
import { cloneDeep } from '@bingads-webui-universal/primitive-utilities';
import { removeDisabledComponents } from '@bingads-webui-campaign-react/smart-component-util';

/**
 * Convert flat view of grid structure to nested view
 * @param { object } flatTree its components are flat array.
 * @param { object } enabledComponentsConfig available components config.
 * Sample: { components: [{}, {}...] }
 * @returns { object } root a nested tree structure
 * Sample: {
 *  id: '*',
 *  children: [{
 *    id: '**',
 *    children: [{
 *      id: '***',
 *      children: [{}, {}...]
 *    }]
 *  }]
 * }
 */
export const buildNestedTree = ({ components, ...rest }, enabledComponentsConfig) => {
  // Remove disabled components so that orderedComponents doesn't include those.
  const allComponents = removeDisabledComponents(cloneDeep(components), enabledComponentsConfig);
  const root = {
    ...rest,
    children: [],
  };
  const idMapping = _.reduce(allComponents, (memo, component, index) => ({
    ...memo,
    [component.id]: index,
  }), {});

  _.each(allComponents, (component) => {
    const { parentId, order } = component;

    if (parentId) {
      // for groups, components
      const parentSection = allComponents[idMapping[parentId]];

      parentSection.children = parentSection.children || [];
      parentSection.children[order] = component;
    } else {
      // for sections
      root.children[order] = component;
    }
  });

  return root;
};
